// Canonical category listing URL (T2.3): shortened from `/categories/@slug`
// to `/c/@slug`. The old path 301-redirects here (see pages/category-legacy).
// Vike's more-specific route wins over the `/*` catch-all, so this renders
// SSR and the React Router SPA no longer mounts for it.
export default '/@lang/c/@slug'
